import { Link } from "react-router-dom";

import sniffing from './notfound-sniffing.gif';
import './NotFoundPage.css';

export default function NotFoundPage() {
  return (
    <div className="not-found-container">
        <span className="header">Sorry! I couldn't sniff out that page <span style={{whiteSpace: 'nowrap'}}>{":("}</span></span>

        <span className="sub">Wanna try <Link to='/'>the homepage</Link>?</span>
        
        <img src={sniffing} alt="SNIIIFF" className="sniffy-wolp" />

        <span className="errorname">404: The server could not find the requested file.</span>
    </div>
  )
}
